const preventMouseWheelValueChange = (event) => {
    if (event.target.type !== "number") return;
    event.target.blur();
};

export default preventMouseWheelValueChange;